import React from "react";
import { useSelector, useDispatch } from "react-redux";
import noImage from "../assets/img/noimage.png";
import axios from "axios";
import { fullOrderType } from "types";

interface UpsellProps {}

const convertHex2Img = (hexCode: string) => {
  if (hexCode === "") {
    return noImage;
  }
  let input = hexCode.replace(/[^A-Fa-f0-9]/g, "");
  if (input.length % 2) {
    return noImage;
  }
  let binary = new Array();
  for (let i = 0; i < input.length / 2; i++) {
    let h = input.substr(i * 2, 2);
    binary[i] = parseInt(h, 16);
  }
  let byteArray = new Uint8Array(binary);
  return window.URL.createObjectURL(new Blob([byteArray], { type: "application/octet-stream" }));
};

const useReduxState = () => {
  return useSelector((state: fullOrderType) => ({
    upsells: state.upsells,
    donation: state.donation,
    donationAk: state.donationAk,
    tickets: state.event.tickets,
    discountSection: state.discountSection,
    coupon: state.discountCode,
  }));
};

const useUpdates = () => {
  //const discount = useSelector((state) => state.discount)
  const dispatch = useDispatch();

  const setUpsell = (from, to) => {
    dispatch({ type: "SET_UPSELL", from, to });
  };
  const updateTotal = (val) => {
    dispatch({ type: "UPDATE_TOTAL", val });
  };
  const updateDiscount = (val) => {
    dispatch({ type: "UPDATE_DISCOUNT", val });
  };
  const setUpsellTicket = (from, upsellTicket) => {
    dispatch({ type: "SET_UPSELL_TICKET", from, upsellTicket });
  };
  return {
    setUpsell,
    updateTotal,
    updateDiscount,
    setUpsellTicket,
  };
};

const Upsell: React.FC<UpsellProps> = () => {
  const { tickets, coupon, donationAk, donation, upsells } = useReduxState();
  const { updateTotal, setUpsell, updateDiscount, setUpsellTicket } = useUpdates();

  const getTickets = () => {
    let selectedTickets = [] as any;
    tickets.forEach((ticket) => {
      if (ticket.num > 0) {
        let upsellID = upsells.findIndex((upsell) => {
          return upsell.from === ticket.id && upsell.active === "on";
        });
        let ticketID = upsellID > -1 ? upsells[upsellID].to : "";
        selectedTickets.push({ id: ticket.id, num: ticket.num, upsell: ticketID });
      }
    });
    // add dpnation as well
    if (donationAk != "" && donation > 0) {
      selectedTickets.push({ id: donationAk, num: 1 });
    }
    return JSON.stringify(selectedTickets);
  };

  const updateBasket = async () => {
    const getTicketsArray = JSON.parse(getTickets());
    const basketdata = await axios.get(`/api/checkbasket?productid=${getTickets()}&coupon=${coupon}`);

    const ticketsArray = [] as any;
    for (let i = 0; i < getTicketsArray.length; i++) {
      ticketsArray.push(getTicketsArray[i].id);
      ticketsArray.push(getTicketsArray[i].upsell);
    }

    const BasketTicketsArray = [] as any;
    if (basketdata.data.response.ITEMLIST.ITEM.id) {
      BasketTicketsArray.push(basketdata.data.response.ITEMLIST.ITEM.id);
    } else {
      for (let i = 0; i < basketdata.data.response.ITEMLIST.ITEM.length; i++) {
        BasketTicketsArray.push(basketdata.data.response.ITEMLIST.ITEM[i].AK._text);
      }
    }

    let newBasketTickets = BasketTicketsArray;
    for (let i = 0; i < getTicketsArray.length; i++) {
      newBasketTickets = newBasketTickets.filter((e) => e !== getTicketsArray[i].upsell);
    }

    // console.log(ticketsArray);
    // console.log(newBasketTickets);

    for (let i = 0; i < newBasketTickets.length; i++) {
      let x = i * 2;

      if (ticketsArray[x] == newBasketTickets[i]) {
        //console.log(`SAME: ${ticketsArray[x]} / ${x} --- ${newBasketTickets[i]} / ${i}`);
        setUpsellTicket(ticketsArray[x], "");
      } else {
        setUpsellTicket(ticketsArray[x], newBasketTickets[i]);
        //console.log(`NOT SAME: ${ticketsArray[x]} / ${x} --- ${newBasketTickets[i]} / ${i}`);
      }
    }

    //console.log("FINAL ARRAY");
    //console.log("\n\n\n\n\n\n");

    if (basketdata.data.response.BASKETTOTAL && basketdata.data.response.BASKETTOTAL.GROSS) {
      updateTotal((parseFloat(basketdata.data.response.BASKETTOTAL.GROSS._text) || 0).toFixed(2));
    } else {
      updateTotal((0).toFixed(2));
    }
    if (
      basketdata.data.response.PROMOTIONAPPLIEDLIST &&
      basketdata.data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED
    ) {
      updateDiscount(
        (parseFloat(basketdata.data.response.PROMOTIONAPPLIEDLIST.PROMOTIONAPPLIED.DISCOUNT._text) * -1 || 0).toFixed(2)
      );
    } else {
      updateDiscount((0).toFixed(2));
    }
    //console.log(basketdata.data.response.ITEMLIST.ITEM);
  };

  return (
    <>
      {upsells &&
        upsells.map((upsell) => (
          <div className="add-offers__offer" key={upsell.product.SHEETNAME._text}>
            <div className="add-offers__details">
              <div className="add-offers__details-picture">
                <img src={convertHex2Img(upsell.img)} />
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setUpsell(upsell.from, upsell.to);
                    updateBasket();
                  }}
                  className="add-offers__details-order-link"
                >
                  {upsell.active === "" ? <>ADD TO ORDER</> : <>REMOVE</>}
                </a>
              </div>
              <div className="add-offers__details-text">
                <div className="add-offers__details-title">
                  <span>{upsell.product.SHEETNAME._text}</span>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setUpsell(upsell.from, upsell.to);
                      updateBasket();
                    }}
                    className="add-offers__details-order-link"
                  >
                    {upsell.active === "" ? <>ADD TO ORDER</> : <>REMOVE</>}
                  </a>
                </div>
                <div className="add-offers__details-fee">
                  {upsell.product.NAME._text} at $
                  {upsell.upsellData.PRODUCTUPSELLITEM.RULELIST.RULEITEM.PRICEDIFFERENCE.GROSS._text}
                </div>
                <div className="add-offers__details-description">{upsell.product.DESCRIPTION._text}</div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default Upsell;
